<template>
    <v-dialog
        v-model="showDialog"
        width="650"
    >
        <v-card>
            <v-card-title style="background-color: #009688; color: white; word-wrap: normal;">
                Do you really want to delete this {{ capitalizeFirstLetter(type).toLowerCase() }}?
            </v-card-title>
            <v-card-text style="max-height: 70vh; overflow-y: scroll; background-color: #EDFFFB;">
                <v-simple-table
                    dense
                    style="background-color: white; border-radius: 20px; padding: 10px 10px 0  10px; margin-top: 25px"
                >
                    <template #default>
                        <tbody>
                            <tr>
                                <td class="text-left">
                                    ID
                                </td>
                                <td>{{ data.ID }}</td>
                            </tr>
                            <tr>
                                <td class="text-left">
                                    MSU CODE
                                </td>
                                <td>{{ data['MSU CODE'] }}</td>
                            </tr>
                            <tr>
                                <td class="text-left">
                                    ACCOUNT CLINIC
                                </td>
                                <td>{{ data['ACCOUNT CLINIC'] }}</td>
                            </tr>
                            <tr>
                                <td class="text-left">
                                    TYPE
                                </td>
                                <td>{{ data.TYPE }}</td>
                            </tr>
                            <tr>
                                <td class="text-left">
                                    SIGNED
                                </td>
                                <td>
                                    <v-icon
                                        v-if="!data.SIGNED"
                                        color="error"
                                    >
                                        {{ mdiCloseCircle }}
                                    </v-icon>
                                    <v-icon
                                        v-else
                                        color="success"
                                    >
                                        {{ mdiCheckCircle }}
                                    </v-icon>
                                </td>
                            </tr>
                            <tr>
                                <td class="text-left">
                                    SIGNED ON
                                </td>
                                <td>{{ formatDateToPst(data['SIGNED ON']) }}</td>
                            </tr>
                            <tr>
                                <td class="text-left">
                                    PREPARED BY
                                </td>
                                <td>{{ data['PREPARED BY'] }}</td>
                            </tr>
                            <tr>
                                <td class="text-left">
                                    PREPARED ON
                                </td>
                                <td>{{ formatDateToPst(data['PREPARED ON']) }}</td>
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>
            </v-card-text>
            <v-card-actions style="background-color: #EDFFFB;">
                <v-spacer />
                <v-btn
                    outlined
                    class="white--text"
                    color="teal darken-1"
                    style="text-transform: none; width: 105px;"
                    @click="showDialog = false"
                >
                    CLOSE
                </v-btn>
                <v-btn
                    color="teal darken-1 white--text"
                    class="white--text"
                    style="text-transform: none; width: 105px; font-weight: 600"
                    :loading="loading"
                    @click="handleDeleteFile"
                >
                    DELETE
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { moment } from '../../../../../../utils/date-shim'
import { mapActions, mapGetters } from 'vuex'
import {
    mdiCloseCircle,
    mdiCheckCircle
} from '@mdi/js'
export default {
    props: ['data', 'show', 'notif'],
    data:()=>({
        mdiCloseCircle,
        mdiCheckCircle,
        loading: false
    }),
    computed: {
        ...mapGetters(['deleteEndorsementConfirmationData']),
        type() {
            if (this.data && this.data.TYPE) {
                return this.data.TYPE.toLowerCase()
            } else {
                return '-'
            }
        },
        showDialog: {
            get() {
                return this.show
            },
            set() {
                this.$emit('closeDialog')
            }
        }
    },
    watch: {
        deleteEndorsementConfirmationData(newVal) {
            if (newVal && newVal.status === 200) {
                this.listEndorsementConfirmation()
                this.notif.type = 'success'
                this.notif.color = 'success'
                this.notif.timeout = 5000
                this.notif.msg = `${this.capitalizeFirstLetter(this.data.TYPE)} has been deleted.`
                this.notif.show = true
                this.notif.dismissible = false
                this.$emit('closeDialog')
            } else {
                this.notif.type = 'error'
                this.notif.color = 'error'
                this.notif.timeout = 5000
                this.notif.msg = newVal.state
                this.notif.show = true
                this.notif.dismissible = false
            }
        }
    },
    methods: {
        ...mapActions(['deleteEndorsementConfirmation', 'listEndorsementConfirmation']),
        capitalizeFirstLetter(str) {
            const type = str.toLowerCase() === 'both' ? 'ENDORSEMENT AND CONFIRMATION' : str
            return type.charAt(0).toUpperCase() + type.slice(1).toLowerCase()
        },
        handleDeleteFile() {
            this.deleteEndorsementConfirmation({ ID: this.data.ID })
        },
        formatDateToPst(date) {
            if (date) {
                return moment(date).utcOffset('+0800').format('MMMM DD, YYYY')
            } else {
                return '-'
            }
        }
    }
}
</script>
